import React from 'react'

const Heading2 = ({ children }) => {
  return <h2>{children}</h2>
}

export default Heading2
